import { BadgeCssClassStatusEnum } from "app/back-office/shared/enum/badge-css-class-status.enum.model";
import { GridColumn, GridColumnTypeEnum } from "app/back-office/shared/models/common/grid-settings.model";
import { OrderStatusTypeEnum } from "app/shared/enums/order-status-type.enum.model";
import { TenantTypeEnum } from "environments/tenant-type.enum";

export enum orderColumnsEnum {
  actions = 1,
  type = 2,
  id = 3,
  name = 4,
  agencyCode = 5,
  pos = 6,
  total = 7,
  date = 8,
  channelName = 9,
  customer = 10,
  store = 11,
  status = 12,
  gok = 13,
  checkbox = 14,
  externalId = 15,
  seasonReference = 16,
  totalQty = 17,
  customizationRequest = 18,
  notes = 19,
  dateOrder = 20,
  dateCart = 21,
  bulk = 22,
  operations = 23
}

export class OrderColumnsListItem {
  isVisible: boolean;
  id: orderColumnsEnum;
  gridColumn: GridColumn;
  hideToCart?: boolean; 
  hideToOrder?: boolean; 
  alwaysVisible?: boolean;
}

export const OrderColumnsList: OrderColumnsListItem[] = [
  {
    isVisible: false,
    id: orderColumnsEnum.actions,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.actions,
      name: '',
      prop: '',
      type: GridColumnTypeEnum.actions,
      width: 50,
      checkable: false
    }),
    alwaysVisible: true
  },
  {
    isVisible: true,
    id: orderColumnsEnum.id,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.id,
      name: 'TABLE.CART.COLUMNS.ID',
      prop: 'id',
      enableClickCell: true,
      width: 85,
      checkable: false
    }),
    alwaysVisible: true
  },
    {
    isVisible: false,
    id: orderColumnsEnum.externalId,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.externalId,
      name: 'TABLE.CART.COLUMNS.EXTERNAL_ID',
      prop: 'externalId',
      enableClickCell: false,
      width: 85,
    }),
    hideToCart: true
  },
  {
    isVisible: true,
    id: orderColumnsEnum.name,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.name,
      name: 'TABLE.CART.COLUMNS.NAME',
      prop: 'name',
      enableClickCell: true,
      minWidth: 150,
      checkable: false
    }),
    alwaysVisible: true
  },
  {
    isVisible: false,
    id: orderColumnsEnum.dateCart,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.dateCart,
      name: 'TABLE.CART.COLUMNS.DATE',
      prop: 'creationTime',
      type: GridColumnTypeEnum.date,
      width: 110,
      enableClickCell: true,
      sortProp: 'creationTime'
    }),
    hideToOrder: true
  },
  {
    isVisible: true,
    id: orderColumnsEnum.dateOrder,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.dateOrder,
      name: 'TABLE.CART.COLUMNS.DATE',
      prop: 'orderConfirmationDate',
      type: GridColumnTypeEnum.date,
      width: 110,
      enableClickCell: true,
      sortProp: 'orderConfirmationDate'
    }),
    hideToCart: true
  },
  {
    isVisible: true,
    id: orderColumnsEnum.customer,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.customer,
      name: 'TABLE.ORDER.COLUMNS.CUSTOMER',
      prop: 'customerName',
      enableClickCell: true,
      minWidth: 125
    })
  },
  {
    isVisible: true,
    id: orderColumnsEnum.pos,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.pos,
      name: 'TABLE.CART.COLUMNS.POS',
      prop: 'posName',
      enableClickCell: true,
      minWidth: 125
    })
  },
  {
    isVisible: true,
    id: orderColumnsEnum.agencyCode,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.agencyCode,
      name: 'TABLE.CART.COLUMNS.AGENCY_CODE',
      prop: 'agencyCode',
      enableClickCell: true,
      width: 85
    })
  },
    {
    isVisible: false,
    id: orderColumnsEnum.seasonReference,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.seasonReference,
      name: 'TABLE.CART.COLUMNS.SEASON_REFERENCE',
      prop: 'seasonReference',
      enableClickCell: true,
      width: 120
    })
  },
  {
    isVisible: true,
    id: orderColumnsEnum.totalQty,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.totalQty,
      name: 'TABLE.CART.COLUMNS.PCS',
      prop: 'totalQuantity',
      type: GridColumnTypeEnum.number,
      width: 80,
      enableClickCell: true,
    })
  },
  {
    isVisible: true,
    id: orderColumnsEnum.total,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.total,
      name: 'TABLE.CART.COLUMNS.TOTAL',
      prop: 'discountedTotalPrice',
      type: GridColumnTypeEnum.price,
      currencyProp: 'currency',
      width: 100,
      sortProp: 'discountedTotalPrice',
      enableClickCell: true,
    })
  },
  {
    isVisible: false,
    id: orderColumnsEnum.gok,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.gok,
      name: 'TABLE.ORDER.COLUMNS.GOK',
      prop: 'isGok',
      type: GridColumnTypeEnum.status,
      width: 120,
      statusLabels: ['STATUS.NOT_GOK', 'STATUS.GOK'],
      enableClickCell: true,
    })
  },
  {
    isVisible: false,
    id: orderColumnsEnum.customizationRequest,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.customizationRequest,
      name: 'ORDER_DETAIL.COLUMNS.CUSTOMIZATION_REQUEST',
      prop: 'customizationRequestId',
      enableClickCell: true,
      width: 120
    }),
    hideToCart: true
  },
  {
    isVisible: false,
    id: orderColumnsEnum.notes,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.notes,
      name: 'ORDER_DETAIL.COLUMNS.NOTE',
      prop: 'note',
      enableClickCell: true,
      width: 120
    })
  },
  {
    isVisible: false,
    id: orderColumnsEnum.channelName,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.channelName,
      name: 'TABLE.CART.COLUMNS.CHANNEL_NAME',
      prop: 'channelName',
      enableClickCell: true,
      width: 120
    })
  },
  {
    isVisible: false,
    id: orderColumnsEnum.type,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.type,
      name: 'TABLE.CART.COLUMNS.TYPE',
      prop: 'type',
      statusLabels: ['STATUS.PRE_ORDER', 'STATUS.RE_ORDER'],
      type: GridColumnTypeEnum.status,
      width: 100,
      enableClickCell: true
    })
  },
  {
    isVisible: true,
    id: orderColumnsEnum.operations,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.operations,
      name: 'TABLE.ORDER.COLUMNS.OPERATIONS',
      prop: 'hasPendingBulkOperations',
      statusLabelsWithCssClass: [
        { label: 'PENDING_BULK.PENDING', cssClass: BadgeCssClassStatusEnum.warning, enumValue: 1 },
        { label: 'PENDING_BULK.SYNCED', cssClass: BadgeCssClassStatusEnum.success, enumValue: 0 }
      ],
      type: GridColumnTypeEnum.status,
      width: 120,
      enableClickCell: false
    }),
    hideToCart: true
  },
  {
    isVisible: true,
    id: orderColumnsEnum.status,
    gridColumn: new GridColumn({
      colId: orderColumnsEnum.status,
      name: 'TABLE.ORDER.COLUMNS.STATUS',
      prop: 'orderStatus',
      statusLabelsWithCssClass: [
        { label: 'STATUS.DRAFT', cssClass: BadgeCssClassStatusEnum.warning, enumValue: OrderStatusTypeEnum.Draft },
        { label: 'STATUS.CREATED', cssClass: BadgeCssClassStatusEnum.info, enumValue: OrderStatusTypeEnum.Created },
        { label: 'STATUS.CONFIRMED', cssClass: BadgeCssClassStatusEnum.success, enumValue: OrderStatusTypeEnum.Confirmed },
        { label: 'STATUS.REJECTED', cssClass: BadgeCssClassStatusEnum.danger, enumValue: OrderStatusTypeEnum.Failed },
        { label: 'STATUS.PARTIALLY_FULFILLED', cssClass: BadgeCssClassStatusEnum.warning, enumValue: OrderStatusTypeEnum.Partially_fulfilled },
        { label: 'STATUS.CANCELLED', cssClass: BadgeCssClassStatusEnum.danger, enumValue: OrderStatusTypeEnum.Cancelled },
        { label: 'STATUS.CONCLUDED', cssClass: BadgeCssClassStatusEnum.secondary, enumValue: OrderStatusTypeEnum.Concluded },
        { label: 'STATUS.SYNCING', cssClass: BadgeCssClassStatusEnum.info, enumValue: OrderStatusTypeEnum.Syncing }
      ],
      type: GridColumnTypeEnum.status,
      width: 160,
      enableClickCell: true
    }),
    hideToCart: true 
  }

];